import { useTranslation } from 'react-i18next';
import classnames from 'classnames';
import s from './index.module.scss';

export const StreakStatus = ({ status }) => {
  const { t } = useTranslation('streak');
  return (
    <div className={classnames(s.status, status, 'f-small-accent')}>
      {t(`streak_status_comp.${status}`)}
    </div>
  );
};
